import { useMemo, useState } from "react";

import { TInputTag } from "components/InputMultipleTag";

import { queryGetClientPost } from "@type/api/user";
import { useAuthStore } from "@type/store";
import { useTranslationContext } from "context/TranslationContext";
import { getTranslationKey } from "helpers/getTranslationKey";
import { useQueryWithCallbacks } from "lib/query/useQueryWithCallbacks";

interface UseGetClientPostProps {
  enabled?: boolean;
}

export const useGetClientPost = ({ enabled }: UseGetClientPostProps) => {
  const user = useAuthStore((state) => state.user);
  const [postOptions, setPostOptions] = useState<TInputTag[]>([]);
  const { t } = useTranslationContext();

  const queryGetClientPostKey = useMemo(() => {
    return queryGetClientPost._key(user.language);
  }, [user.language]);

  const { isLoading } = useQueryWithCallbacks({
    queryKey: queryGetClientPostKey,
    enabled: !!user?.idUnique && enabled,
    queryFn: () => queryGetClientPost(user.language),
    onSuccess: (res) => {
      const postList: TInputTag[] = res.data.posts.map((post) => ({
        id: post.id,
        name: t(getTranslationKey(post.name)),
      }));
      postList.sort((a, b) =>
        a.name.toLowerCase() > b.name.toLowerCase() ? 1 : -1
      );
      setPostOptions(postList);
    },
  });

  return {
    isLoadingClientClientPost: isLoading,
    postOptions,
  };
};
